export class GoogleMaps {
    constructor(mapEl) {
        if (!mapEl) return;

        this.mapWrapper = mapEl;
        this.init();
    }

    init() {
        this.mapInstance = null;
        this.markers = [];
        this.infoWindow = null;
        this.activeMarker = null;
    }

    async initMap(id = null) {
        await google.maps.importLibrary('maps');
        const { AdvancedMarkerElement } = await google.maps.importLibrary(
            'marker'
        );

        const points = JSON.parse(this.mapWrapper.getAttribute('data-point'));
        if (!points) return;

        this.markers = [];
        this.infoWindow = new google.maps.InfoWindow();

        this.mapInstance = new google.maps.Map(this.mapWrapper, {
            zoom: 14,
            center: {
                lat: parseFloat(points[0].lat),
                lng: parseFloat(points[0].lng),
            },
            mapId: 'map',
        });

        points.forEach(point => {
            const marker = new AdvancedMarkerElement({
                map: this.mapInstance,
                position: {
                    lat: parseFloat(point.lat),
                    lng: parseFloat(point.lng),
                },
                title: point.title,
            });

            marker.addEventListener('click', () => {
                this.onMarkerClick(marker);
            });

            this.markers.push({
                id: point.id,
                marker,
                data: point,
            });
        });

        if (id) {
            const item = this.markers.find(m => m.id == id);
            if (item) {
                item.marker.click();
            }
        }
    }
    onMarkerClick(marker) {
        const item = this.markers.find(m => m.marker === marker);

        if (this.activeMarker === marker) {
            this.infoWindow.close();
            this.activeMarker = null;
            return;
        }

        this.infoWindow.setContent(this.createMarkerContent(item.data));

        this.infoWindow.open({
            map: this.mapInstance,
            anchor: marker,
        });

        this.activeMarker = marker;
    }
    goToMarker(id) {
        const item = this.markers.find(m => m.id == id);

        if (!item) return;

        const position = item.marker.position;

        this.mapInstance.panTo(position);
        this.mapInstance.setZoom(14);
        item.marker.click();
    }

    createMarkerContent(data) {
        return `
        <div class="flex flex-col gap-4 font-primary">
            <p class="text-small font-medium text-text-primary">${data.title}</p>
            <p class="text-small text-text-primary">${data.address}</p>
        </div>
    `;
    }
}
